// extracted by mini-css-extract-plugin
var _1 = "Status-modulestatus__sQfjb Tag-moduleTag__FLr9H";
export { _1 as "status" }
